import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";

export const deleteMemberJournal = ({ churchId, journalId }) => {
  return axios.delete(`/churches/${churchId}/member-journals/${journalId}`);
};

export const useDeleteMemberJournal = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const closeDeleteModal = useCentralStore.getState().closeDeleteModal;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(["member-journals"]);
      setNotification({
        type: "success",
        message: "Member journal deleted successfully!"
      });
      closeDeleteModal();
    },
    ...config,
    mutationFn: deleteMemberJournal
  });
};
